<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qc3Mfm/tc-custom/cover.jpg?1685327424665?1692044794263" alt="This image is the cover for the book Hat Trick Overtime: Summer Camp, Hat Trick (Simon and Alex)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hat Trick Overtime: Summer Camp, Hat Trick (Simon and Alex)
      </h1>
      <p class="bookDescription body article font2">
        <p>Simon and Alex, now between their junior and senior years at the University of Michigan, decide to put their jobs on hold for a month and take the opportunity to coach hockey at a summer camp for teenagers.<br/><br/>They have a cabin full of good players to work with and the focus is getting them ready to win the camp championship. One camper, sixteen-year-old Dylan, requests extra help because he needs to get a scholarship and the guys make it their mission to help him succeed.<br/><br/>With their best friend Leo along for the trip, Simon and Alex are set up for a great time at camp, until another coach tries to seduce them. How they respond to the unwanted advances, while balancing commitments to their campers, will put them both -- and their relationship -- to the test.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Adams
      </h2>
      
      <p class="authorDescription body article">Jeff lives in rural Northern California with his husband of twenty years, Will. He’s the author of the young adult/new adult Hat Trick series, as well as other short stories and novellas. He also co-hosts the weekly show Jeff & Will’s Big Gay Fiction Podcast. For more information, visit JeffAdamsWrites.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8bb6ac0